/*
 *  (c) 2015 - 2024 ENISCO by FORCAM GmbH
 */

import React, {useCallback} from 'react'
import {useDrop} from 'react-dnd'
import {DeleteOpen} from '../../icon/DeleteOpen'
import {Delete} from '@mui/icons-material'
import {App} from '../../model/apps'
import appIdConverter from '../helper/appIdConverter'
import useProfile from '../../hooks/useProfile'
import useRegisteredApps from '../../hooks/useRegisteredApps'
import useFavoriteApps from '../../hooks/useFavoriteApps'


interface AppItem {
  object: any
}

const QuickLaunchDelete: React.FC<object> = () => {
  const [profile, setProfile] = useProfile()
  const [registeredApps] = useRegisteredApps()
  const [registeredFavorites] = useFavoriteApps()

  const deleteApp = useCallback( (app: App) => {
    const tmp = appIdConverter(
      profile?.quickLaunchApps ?? [],
      registeredApps,
      registeredFavorites
    )
    const newApps = tmp.filter((appFilter) => {
      return !(
        app.module === appFilter.module &&
        app.app === appFilter.app &&
        app.favoriteId === appFilter.favoriteId
      )
    })
    setProfile({quickLaunchApps: newApps, quickLaunchCustomized: true})
  }, [profile?.quickLaunchApps, registeredApps, registeredFavorites])

  const [{isActive, isOver}, drop] = useDrop<
    AppItem,
    void,
    {isActive: boolean; isOver: boolean}
  >(() => ({
    accept: 'QuickLaunchApp',
    collect: (monitor) => ({
      isActive: monitor.canDrop() && !monitor.isOver(),
      isOver: monitor.isOver()
    }),
    drop(item: AppItem) {
      deleteApp(item.object)
    }
  }), [deleteApp])

  return (
    <div ref={(r) => {
      drop(r)
    }}>
      {isOver ? (
        <DeleteOpen
          data-testid={'QuickLaunchDelete:delete_open'}
          width={'32px'}
          height={'32px'}
        />
      ) : undefined}
      {isActive ? (
        <Delete
          data-testid={'QuickLaunchDelete:delete_open'}
          width={'32px'}
          height={'32px'}
        />
      ) : undefined}
    </div>
  )
}

export default QuickLaunchDelete
